interface DropdownProps {
  label: string;
  options: { category_code: string; category_name: string }[];
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string;
}

const Dropdown: React.FC<DropdownProps> = ({ label, options, onChange, value }) => (
  <div className="flex flex-col">
    <label className="mb-1 text-sm font-medium">{label}*</label>
    <select
      className="border border-gray-300 rounded-md p-2 focus:ring-green-500 focus:border-green-500"
      onChange={onChange}
      value={value}
    >
      <option value="">--Select--</option>
      {options.map((option) => (
        <option key={option.category_code} value={option.category_code}>
          {option.category_name}
        </option>
      ))}
    </select>
  </div>
);

export default Dropdown;
